import React from 'react'

const Tempdatalist = () => {
    return (
        <>
            <datalist id="players"><option value="Akai"></option><option value="Bashe"></option><option value="Beelzebae"></option><option value="Bjorn"></option><option value="Blank"></option><option value="Brent"></option><option value="CWheezy"></option><option value="CaliScrub"></option><option value="Chunks"></option><option value="Code Monkey"></option><option value="CuteDispenser"></option><option value="Dasterin"></option><option value="Dekodere"></option><option value="Ectogasm"></option><option value="FUTT"></option><option value="Grey"></option><option value="Imp Retro"></option><option value="Kayin"></option><option value="Kayladoscopes"></option><option value="Knux"></option><option value="Krackatoa"></option><option value="Licareo"></option><option value="Lofo"></option><option value="Mapachito"></option><option value="Miko"></option><option value="Nanoot"></option><option value="Patito"></option><option value="Princess Kiss"></option><option value="RTW"></option><option value="Roth"></option><option value="Ruby"></option><option value="Ryyudo"></option><option value="Sage"></option><option value="Satchamobob"></option><option value="Sev"></option><option value="Shawn"></option><option value="Shay"></option><option value="Smiler"></option><option value="Sol Arcana"></option><option value="Syd"></option><option value="Taikuando"></option><option value="Theophrastus"></option><option value="Trumpet"></option><option value="TuxJam"></option><option value="Tuxdev"></option><option value="WillGallant"></option><option value="Winter"></option><option value="Zerker"></option><option value="Zwei"></option></datalist>
            <datalist id="teams">
                <option value="Scary Monsters:YuzuYEEHAW:Syd"></option>
                <option value="The school of the Undefeated of the South! The winds of the king! Zenshin! Keiretsu! Tenpa Kyoran! Look! the South is burning red!:Master Chunks:Knux Kasshu"></option>
                <option value="We're Devilman Too:Winter:Satchamobob"></option>
                <option value="Leggy:Akai:Roth"></option>
                <option value="Demon Girl Gang:Ruby:Shay"></option>
                <option value="The Chain Gang:Imp Retro:Korbp"></option>
                <option value="Who's on Counter Hit?:WillGallant:Nanoot"></option>
                <option value="Please Buy YOLO Stock:CaliScrub:CaliBro"></option>
                <option value="The Thigh Inquisitors:Blank:Taiku:"></option>
                <option value="「FIGHTING☆DREAMERS」:Shawn:Code Monkey"></option>
                <option value="Ghoul N Ghosts:Bwarch:Trynant"></option>
                <option value="Head and Shoulders:Miko:Shadow Miko"></option>
            </datalist>
            <datalist id="chars">
                <option value="answer"></option>
                <option value="axl"></option>
                <option value="baiken"></option>
                <option value="bed"></option>
                <option value="chipp"></option>
                <option value="dizzy"></option>
                <option value="elphelt"></option>
                <option value="faust"></option>
                <option value="ino"></option>
                <option value="jacko"></option>
                <option value="jam"></option>
                <option value="johnny"></option>
                <option value="kum"></option>
                <option value="ky"></option>
                <option value="leo"></option>
                <option value="may"></option>
                <option value="millia"></option>
                <option value="pot"></option>
                <option value="ram"></option>
                <option value="raven"></option>
                <option value="sin"></option>
                <option value="slayer"></option>
                <option value="sol"></option>
                <option value="venom"></option>
                <option value="zato"></option>
            </datalist>
        </>
    )
}

export default Tempdatalist
